import React from "react";

import benefits from '../../../assets/images/benefits.jpg';
import check from '../../../assets/images/benefits-check.svg';

const Benefits = () => {
  return (
    <section className="utility-collection">
        <div className="container mx-auto">
            <div className="benefits-header text-center">
                <h1 className="lt-white font-bold">The MetaFans NFT Collections</h1>
                <h2 className="text-grey">We love art, blockchain, and sports but there’s nothing like community!  MetaFans NFT collectors are part of an active, growing community where you can share your love of sports and enjoy VIP IRL experiences!</h2>
            </div>
            <div className="benefits-info flex flex-col-reverse lg:flex-row items-start justify-center">
                <div className="w-full lg:w-1/2">
                    <h1 className="lt-white font-bold">No other sport-focused NFT has the utility MetaFans has!</h1>
                    <div className="benefits-list lt-white">
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>IRL gatherings, parties, and VIP experiences!</p>
                            </div>
                        </div>
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>Weekly online events, prizes, and giveaways.</p>
                            </div>
                        </div>
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>Giveaways to VIP experiences including concerts, festivals, sporting events, and more!</p>
                            </div>
                        </div>
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>Sports pools, football squares, playoff brackets, weekly sports pick’ems.</p>
                            </div>
                        </div>
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>Exclusive access to the MetaFans ticket site, for the best aftermarket ticket prices.</p>
                            </div>
                        </div>
                        <div className="flex align-center justify-start single-benefit">
                            <div className="w-1/12">
                                <img src={check} alt="metafans benefits"></img>
                            </div>
                            <div>
                                <p>Exclusive access to our Clubhouse app (coming soon!), the ultimate MetaFans VIP companion app.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 mt-5 lg:mt-0">
                    <img className="mx-auto" src={benefits} alt="Metafans Benefits"></img>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Benefits;